import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getProfileAssetUrl } from '../utils/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Mail, Phone, Settings } from 'lucide-react';

export default function Profile() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    navigate('/login');
    return null;
  }

  const userAvatarUrl = user.avatar
    ? (user.avatar.startsWith('http') ? user.avatar : getProfileAssetUrl(user.avatar))
    : null;
  const initials = [user.first_name?.[0], user.last_name?.[0]].filter(Boolean).join('').toUpperCase() || 'U';

  return (
    <div className="space-y-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-white">My Profile</h1>
      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <div className="flex items-center gap-4">
            <Avatar className="h-20 w-20 border-2 border-slate-600">
              {userAvatarUrl ? (
                <AvatarImage src={userAvatarUrl} alt={user.first_name} />
              ) : null}
              <AvatarFallback className="bg-slate-700 text-white text-2xl">
                {initials}
              </AvatarFallback>
            </Avatar>
            <div>
              <CardTitle className="text-xl text-white">
                {user.first_name} {user.last_name}
              </CardTitle>
              <p className="text-slate-400">{user.role}</p>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-3 text-slate-300">
            <Mail className="h-5 w-5 text-slate-500" />
            <span>{user.email || '—'}</span>
          </div>
          {user.phone && (
            <div className="flex items-center gap-3 text-slate-300">
              <Phone className="h-5 w-5 text-slate-500" />
              <span>{user.phone}</span>
            </div>
          )}
        </CardContent>
      </Card>
      <div className="flex flex-wrap gap-3">
        <Button
          onClick={() => navigate('/settings')}
          variant="outline"
          className="border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
        >
          <Settings className="h-4 w-4 mr-2" />
          Settings
        </Button>
      </div>
    </div>
  );
}
